module.exports = __webpack_public_path__ + "static/media/companygreen-new.83e396a5.svg";